import { NgModule } from '@angular/core';
import { LazyLoadImageDirective } from './lazyload-image.directive';

@NgModule({
    declarations: [ LazyLoadImageDirective ],
    exports: [ LazyLoadImageDirective ]
})
export class LazyLoadImageModule {}



// WEBPACK FOOTER //
// ./src/app/modules/lazy-load/lazyload-image.module.ts